export default "__VITE_ASSET__B5TefTn2__"